import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';

import styles from './mobilePage.module.css';

const MobileBackButton = (props) => {
  const { t } = useTranslation();
  return (
    <Button className={styles.button} size="flex" {...props}>
      {t('hotel.cigarette.mobile.backButton')}
    </Button>
  );
};

MobileBackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default MobileBackButton;
